
/**
 * Custom Price Changer for Product Detail Page (PDP)
 * 
 * This script handles dynamic price updates for Kaching bundles on product pages.
 * It monitors clicks on bundle options and updates the main product price display
 * to reflect the selected bundle's pricing.
 * 
 */

document.addEventListener('DOMContentLoaded', function() {
    // Function to process selected bar
    function processSelectedBar(selectedBar) {
        if (selectedBar) {
            // Find price elements within the selected div
            const normalPrice = selectedBar.querySelector('.kaching-bundles__bar-price');
            const fullPrice = selectedBar.querySelector('.kaching-bundles__bar-full-price');
            
            // Update prices if both elements are found
            if (normalPrice && fullPrice) {
                changePrice(normalPrice, fullPrice);
            }
        }
    }

    // Check for initially selected bar on page load
    const initiallySelectedBar = document.querySelector('.kaching-bundles__bar--selected');
    if (initiallySelectedBar) {
        processSelectedBar(initiallySelectedBar);
    }

    function changePrice(normalPrice, fullPrice) {
        // Add timeout to wait for elements to be rendered
        setTimeout(function() {
            const originalPrice = document.querySelector('.ed-buy-box .price--highlight');
            const originalComparePrice = document.querySelector('.ed-buy-box .price--compare');
            let discountSavings = document.querySelector('.ed-buy-box .product-meta__price-list-container .product-meta__label-list');

            if (originalPrice && originalComparePrice) {
                // Update prices
                originalPrice.textContent = normalPrice.textContent.trim();
                originalComparePrice.textContent = fullPrice.textContent.trim();
                
                // Calculate discount savings (originalComparePrice - originalPrice)
                if (discountSavings) {
                    // Extract numeric values from price strings (remove currency symbols, commas, etc.)
                    const originalPriceValue = parseFloat(originalPrice.textContent.replace(/[^\d.,]/g, '').replace(',', '.'));
                    const comparePriceValue = parseFloat(originalComparePrice.textContent.replace(/[^\d.,]/g, '').replace(',', '.'));
                    
                    if (!isNaN(originalPriceValue) && !isNaN(comparePriceValue)) {
                        const savings = comparePriceValue - originalPriceValue;
                        // Replace existing content with new savings text
                        discountSavings.innerHTML = `<span style="font-weight: 600;">Save $${savings.toFixed(2)}</span>`;
                    }
                }
            }
        }, 300);
    }

    // Add event listener for clicks on kaching-bundles__bars divs
    document.addEventListener('click', function(event) {
        // Check if the clicked element is a kaching-bundles__bar or inside one
        const clickedBar = event.target.closest('.kaching-bundles__bar');
        
        if (clickedBar) {
            // Process the clicked bar directly
            processSelectedBar(clickedBar);
        }
    });

    // Add event listener for changes in input with name="id"
    const idInput = document.querySelector('input[name="id"]');
    if (idInput) {
        idInput.addEventListener('change', function() {
            // Add timeout to wait for elements to be rendered
            setTimeout(function() {
                // Find the currently selected bar and process it
                const selectedBar = document.querySelector('.kaching-bundles__bar--selected');
                if (selectedBar) {
                    processSelectedBar(selectedBar);
                }
            }, 300);
        });
    }
}); 